export enum IconsNames {
  Alarm = 'alarm',
  Android = 'android',
  Badge = 'badge',
  BadgeC = 'badge-c',
  Bank = 'bank',
  Bell = 'bell',
  BlankCalendar = 'blank-calendar',
  BiDownload = 'bi-download',
  BlackList = 'black-list',
  Bolt = 'bolt',
  Bookmark = 'bookmark',
  BootcampFivers = 'bootcamp-5ers',
  Burn = 'burn',
  BulletPoint = 'bullet-point',
  BxChat = 'bx-chat',
  BxRefresh = 'bx-refresh',
  Camera = 'camera',
  Calendar = 'calendar',
  CardBadge = 'card-badge',
  CardBadgeMobile = 'card-badge-mobile',
  CaretDown = 'caret-down',
  CaretUp = 'caret-up',
  Cash = 'cash',
  CertificateCheck = 'certificate-check',
  ChartAverage = 'chart-average',
  ChartClusterBar = 'chart-cluster-bar',
  ChartLine = 'chart-line',
  ChartLinear = 'chart-linear',
  ChartLineSmooth = 'chart-line-smooth',
  ChartPostContest = 'chart-post-contest',
  ChartStepper = 'chart-stepper',
  Chat = 'chat',
  Check = 'check',
  CaretRight = 'caret-right',
  CheckCircle = 'check-circle',
  ExclamationCircle = 'exclamation-circle',
  ExclamationTriangle = 'exclamation-triangle',
  CloseCircle = 'close-circle',
  InfoCircle = 'circle-info',
  CheckTwo = 'check-two',
  Chess = 'chess',
  ChevronDown = 'chevron-down',
  ChevronLeft = 'chevron-left',
  ChevronRight = 'chevron-right',
  ChevronUp = 'chevron-up',
  Close = 'close',
  ClockOutline = 'clock-outline',
  CloudAuditing = 'cloud-auditing',
  CloudMonitoring = 'cloud-monitoring',
  CoinBag = 'coin-bag',
  CoinBagLine = 'coin-bag-line',
  Compass = 'compass',
  Contest = 'contest',
  CpEdit = 'cp-edit',
  CreateTradeTalkConfirmation = 'create-trade-talk-confirmation',
  Credit = 'credit',
  CreditCardTwoBack = 'credit-card-two-back',
  DayTradingTTP = 'day-trading-ttp',
  Diamond = 'diamond',
  Discord = 'discord',
  Dots = 'dots',
  Download = 'download',
  DragAndDrop = 'drag-and-drop',
  Duplicate = 'duplicate',
  Dpad = 'dpad',
  Earth = 'earth',
  EarthFilled = 'earth-filled',
  Edit = 'edit',
  Ellipse = 'ellipse',
  Event = 'event',
  Exchange = 'exchange',
  ExperienceFivers = 'experience-fivers',
  Eye = 'eye',
  EyeClosed = 'eye-closed',
  Fail = 'fail',
  Facebook = 'facebook',
  FacebookNew = 'facebook-new',
  FiversCredit = 'fivers-credit',
  Flag = 'flag-circle',
  FlagV = 'flag-v',
  Gauge = 'gauge',
  GalleryExport = 'gallery-export',
  GroupAccount = 'groupAccount',
  Heart = 'heart',
  HeartFilled = 'heartFilled',
  HeartHandshake = 'heart-handshake',
  HighStakesFivers = 'high-stakes-5ers',
  Horse = 'horse',
  HourGlass = 'hourglass',
  HyperGrowthFivers = 'hyper-growth-5ers',
  Hemisphere = 'hemisphere',
  Instagram = 'instagram',
  InvoiceOutline = 'invoice-outline',
  iOS = 'ios',
  LayoutDashboard = 'layout-dashboard',
  Lightning = 'lightning',
  LightbulbFilament = 'lightbulb-filament',
  Link = 'link',
  Linkedin = 'linkedin',
  Linux = 'linux',
  LoadMore = 'load-more',
  Lock = 'lock',
  Mac = 'mac',
  Megaphone = 'megaphone',
  MegaphoneNew = 'megaphone-new',
  MenuBurger = 'menu-burger',
  MenuBurgerClose = 'menu-burger-close',
  ModalPopup = 'modal-popup',
  MostPopular = 'most-popular',
  MoonStars = 'moon-stars',
  MountainTop = 'mountain-top',
  MagnifyingGlass = 'magnifying-glass',
  NotFound = 'not-found',
  NotRequired = 'not-required',
  NoSearchResult = 'no-search-result',
  NotVerified = 'not-verified',
  OrderedList = 'ordered-list',
  Password = 'password',
  PCredit = 'p-credit',
  People = 'people',
  PeopleGroup = 'people-group',
  Pencil = 'pencil',
  Person = 'person',
  PersonTwo = 'person-two',
  Phone = 'phone',
  PhoneCare = 'phone-care',
  Play = 'play',
  PlayCircle = 'play-circle',
  Plus = 'plus',
  PlusDiamond = 'plus-diamond',
  Plug = 'plug',
  PodiumRibbon = 'podium-ribbon',
  Publish = 'publish',
  PublishPen = 'publish-pen',
  QuestionCircle = 'question-circle',
  Recycle = 'recycle',
  Refresh = 'refresh',
  Retry = 'retry',
  Rejected = 'rejected',
  Rocket = 'rocket',
  Basecamp = 'basecamp',
  ZeroLimits = 'zero-limits',
  Room = 'room',
  Rules = 'rules',
  RuleThePoolTTP = 'rule-the-pool-ttp',
  Search = 'search',
  ShieldWithTickMark = 'shield-with-tick-mark',
  Shield = 'shield',
  Share = 'share',
  ShareNew = 'share-new',
  SmileRatingFive = 'smile-rating-5',
  SmileRatingFour = 'smile-rating-4',
  SmileRatingOne = 'smile-rating-1',
  SmileRatingThree = 'smile-rating-3',
  SmileRatingTwo = 'smile-rating-2',
  Snow = 'snow',
  Sparkle = 'sparkle',
  Sparkles = 'sparkles',
  Star = 'star',
  StepArrow = 'step-arrow',
  Sun = 'sun',
  SwingTTP = 'swing-ttp',
  TableColumnVisibility = 'column-visibility',
  TableFilter = 'filter',
  TableFullScreen = 'full-screen',
  TableNoColumnVisibility = 'no-column-visibility',
  TableNoFilter = 'no-filter',
  TableNoFullScreen = 'no-full-screen',
  TableNoSearch = 'no-search',
  TableRowSizeLarge = 'row-size-large',
  TableRowSizeMedium = 'row-size-medium',
  TableRowSizeSmall = 'row-size-small',
  TableSearch = 'search-table',
  ThreeDots = 'three-dots',
  Tiktok = 'tiktok',
  Trash = 'trash',
  TrendingDown = 'trending-down',
  TrendingUp = 'trending-up',
  Trophy = 'trophy',
  Twitter = 'x',
  TypeBold = 'type-bold',
  TypeItalic = 'type-italic',
  TypeStrikethrough = 'type-strikethrough',
  TypeUnderline = 'type-underline',
  TextAlignLeft = 'text-align-left',
  TextAlignCenter = 'text-align-center',
  TextAlignRight = 'text-align-right',
  TextAlignJustify = 'text-align-justify',
  Umbrella = 'umbrella',
  UnderReview = 'under-review',
  Union = 'union',
  UnorderedList = 'unordered-list',
  UpToDate = 'up-to-date',
  Validation = 'validation',
  VerificationBadge = 'verification-badge',
  Warning = 'warning',
  Web = 'web',
  Whatsapp = 'whatsapp',
  Windows = 'windows',
  Youtube = 'youtube',
  TableEdit = 'table-edit',
  TableDelete = 'table-delete',
  Cart = 'cart',
  TriangleDown = 'triangle-down',
  Coupon = 'coupon',
  ArrowLeftShort = 'arrow-left-short',
  Stop = 'stop',
  FlagModal = 'flag-modal',
  User = 'user',
}
